module.exports = __webpack_public_path__ + "static/img/AI报账_image@2x.c42aba37.png";